var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g({staticClass:"base-card",attrs:{"tag":"button"}},_vm.$listeners),[_c('div',{staticClass:"base-header"},[_vm._t("top-left"),_vm._t("top-right")],2),_c('div',{staticClass:"base-info"},[_vm._t("middle")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }